export default __webpack_public_path__ + "static/media/instagram_black_icon.a311d466.svg";